import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export interface CouponImageTagTicketProps {
  titlePrefix: ReactNode
  titleSuffix: ReactNode
}

export const CouponImageTagTicket = (props: CouponImageTagTicketProps) => {
  const { titlePrefix, titleSuffix } = props
  return (
    <Box
      px={2}
      py="3px"
      height={30}
      borderRadius={4}
      color={colors.white}
      backgroundImage="linear-gradient(180deg, #FF7671 0%, #FF5353 100%)"
      overflow="hidden"
      position="relative"
    >
      <HStack alignItems="flex-end" justifyContent="center" gap={0.5}>
        <Text variant="subtitle" lineHeight="24px" fontSize="14px">{titlePrefix}</Text>
        <Text variant="h3" lineHeight="24px" fontSize="18px">{titleSuffix}</Text>
      </HStack>
      <Box position="absolute" width={8} height={8} top="50%" left={0} backgroundColor={colors.white} borderRadius="50%" transform="translate(-50%, -50%)" />
      <Box position="absolute" width={8} height={8} top="50%" right={0} backgroundColor={colors.white} borderRadius="50%" transform="translate(50%, -50%)" />
    </Box>
  )
}
